import ContainerProjectManagement from '../../../Component/Dashboard/ProjectManagement/ProjectManagement'

const ProjectManagement = () => {
  return (
    <div className='page-body'>
      <ContainerProjectManagement />
    </div>
  )
}

export default ProjectManagement